export default "__VITE_ASSET__C9_XVeSf__"